import { ReturnReason, ReturnType } from './return-request.interface';

export declare interface ReturnInfo {
  isAutoReturnable: boolean;
  eligibleThrough?: string;
  returnThrough?: string;
  dateRequested?: string;
  dateCompleted?: string;
  status: ReturnStatus;
  returnCondition?: ReturnCondition;
  returnReason?: ReturnReason;
  caseNumber?: string;
  returnType?: ReturnType;
}

export enum ReturnCondition {
  RETURN_CASE = 'ReturnCase',
  PRINT_WITH_ADDRESS = 'PrintWithAddress',
  PRINT_WITHOUT_ADDRESS = 'PrintWithoutAddress',
  PRINT_WITHOUT_ADDRESS_12_MONTHS = 'PrintWithoutAddress12Months',
  WPR = 'WPR',
  CONTACT_SUPPORT_1 = 'ContactSupport1',
  CONTACT_SUPPORT_2 = 'ContactSupport2',
  CONTACT_SUPPORT_INTL = 'ContactSupportIntl',
  CONTACT_SUPPORT_FIRST_AID_FORWARD = 'ContactSupportFirstAidForward',
  CONTACT_SUPPORT_BOARDS_AND_BEYOND = 'ContactSupportBoardsandBeyond',
  CONTACT_SUPPORT_PK12_CUSTOM_BOOKSTORE = 'ContactSupportPK12CustomBookstore',
}

export enum ReturnStatus {
  RETURNABLE = 'returnable',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  NON_RETURNABLE = 'non_returnable'
}